import React from "react";

const NavBar = () => {
  return (
    <nav className="navbar navbar-light bg-dark mb-3 sticky-top">
      <center><div className="container-fluid text-light text-center">
        <center><h3 className="text-light">Sorting Algorithms Visualizer</h3></center>
      </div></center>
      
    </nav>
  );
};

export default NavBar;
